import React from "react";
import RightArrow from "assets/images/button.png";
import Refresh from "assets/images/bx_refresh.png";
import moment from 'moment';
import { useNavigate } from "react-router-dom";

function MoodLog({data, refreshMoodLogs, setRefreshMoodLogs }) {
  const navigate = useNavigate();

  const onHandleClickButton = () => {
    navigate("/mood-overview");
  }

  const onHandleRefreshLogsMood = () => {
    setRefreshMoodLogs(refreshMoodLogs + 1);
  }

  return (
    <div className="max-w-screen-lg mx-auto rounded-t-[80px] bg-custom-pink mt-[-80px] mb-[-100px]">
      <div className="pt-[50px] px-[50px] pb-[50px] w-full">
        <div className="flex justify-between">
          <div className="flex w-1/2">
            <h1 className="font-gluten font-bold text-4xl text-white">Mood Log</h1>
          </div>
          <div 
            className="flex flex-row-reverse w-1/2 cursor-pointer"
            onClick={onHandleRefreshLogsMood}
          >
            <div className="flex flex-col overflow-hidden">
              <span className="font-medium ml-[11px] text-[22px] tracking-[0.44px] text-white">
                Refresh
              </span>
            </div>
            <img
                src={Refresh}
                className="w-[28px] h-[28px]"
                alt=""
            />
          </div>
        </div>
        <div className="grid grid-cols-2 gap-[25px] mt-[50px]">
          {data.map((item, index) => {
            const firstName = item?.child_details?.first_name;
            const childFirstName = firstName !== undefined ? firstName[0].toUpperCase() + firstName.slice(1) : "";
            return (
              <div
                key={index}
                className="px-[25px] py-[35px] flex items-center overflow-hidden rounded-[44px] bg-white relative"
              >
                <div className="w-[94px] mr-[25px] flex-shrink-0">
                  <img src={item.mood_details.image_url} className="w-full" alt="" />
                </div>
                <div className="flex items-center justify-between w-full">
                  <div className="flex flex-col gap-[25px] overflow-hidden">
                    <h4 className="text-2xl text-black font-bold leading-1">
                      {childFirstName} is {item.mood_details.title}
                    </h4>
                    <p className="text-lg font-bold text-form-color tracking-[2.34px] opacity-[0.6] leading-1">
                      {moment(item.log_datetime).format('HH:ssA')}
                    </p>
                  </div>
                  <img
                    src={RightArrow}
                    className="w-[25px] flex-shrink-0"
                    alt=""
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className="flex justify-center mt-[25px]">
          <div 
            className="bg-custom-navy rounded-[99px] h-[66px] w-[264px] flex items-center justify-center text-white text-2xl font-bold leading-[21px] tracking-[0.96px] cursor-pointer"
            onClick={onHandleClickButton}
          >
            Log Child&apos;s Mood
          </div>
        </div>
      </div>
    </div>
  );
}

export default MoodLog;
